import React from 'react'
// libs
import styled from 'styled-components'
// components
import { ReduxCheckbox } from 'components/FormElements'
// context
import { GlobalSearchAPIContext } from 'containers/GlobalSearch/layers/API'
// themes
import { colors } from 'themes'

// styled
const FilterWrapper = styled('div')`
  background-color: ${colors.white100};
  display: flex;
  flex-direction: column;
  font-size: 14px;
  min-width: 160px;

  label {
    padding-right: 0;
  }
`

// constants
export const FILTER_OPTIONS = [
  { label: 'Show Plans ', name: 'showPlans' },
  { label: 'Show Objectives', name: 'showObjectives' },
  { label: 'Show Actions', name: 'showActions' },
  { label: 'Show Indicators', name: 'showKPIs' }
]

const SearchFilter: React.FC = () => {
  const { handleFilterChange } = React.useContext(GlobalSearchAPIContext)

  return (
    <FilterWrapper>
      {FILTER_OPTIONS.map((option) => (
        <ReduxCheckbox key={option.name} option={option} name={option.name} handleOnChange={handleFilterChange} />
      ))}
    </FilterWrapper>
  )
}

export default SearchFilter
